import { render } from "./ModalResponsavelLegal.vue?vue&type=template&id=12aae17a"
import script from "./ModalResponsavelLegal.vue?vue&type=script&lang=js"
export * from "./ModalResponsavelLegal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__